import { Button, Grid } from "@mui/material"
import { makeStyles } from "@mui/styles";
import { THEME } from "../../config";
import { ReactNode } from "react";

const useStyles = makeStyles(() => ({
    button: {
        width: "100%",
        justifyContent: "flex-start",
        textAlign: "left",
        paddingTop: "0.5rem",
        paddingBottom: "0.5rem",
        boxShadow: "0",
        borderRadius: "0",
        color: "inherit"
    },
    gridTabActive: {
        borderLeftWidth: "3px",
        borderLeft: "solid",
        borderLeftColor: THEME.palette.primary.main,
        backgroundColor: THEME.palette.primary.light,
        color: THEME.palette.primary.main
    },
    gridTabNotActive: {
        borderLeftWidth: "3px",
        borderLeft: "solid",
        borderLeftColor: "transparent",
    }
}))

interface ISidebarButtonProps<T> {
    children?: ReactNode;
    activeTab: boolean
    setTab: (type: any) => void
    tab: T
}

const SidebarButton = <T,>(props: ISidebarButtonProps<T>): React.ReactElement => {

    const classes = useStyles();

    const handleButtonClick = (type: T) => {
        props.setTab(type)
    }

    return (
        <Grid item xs={12} className={props.activeTab? classes.gridTabActive : classes.gridTabNotActive}>
            <Button onClick={() => {handleButtonClick(props.tab)}} className={classes.button} variant={"text"}>
                {props.children}
            </Button>
        </Grid>
    )
}

export default SidebarButton